module.exports = __webpack_public_path__ + "static/media/blog.cad11309.svg";